// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "./Icon", "./Secondary", "./Primary"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("./Icon"), require("./Secondary"), require("./Primary"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.Icon, global.Secondary, global.Primary);
    global.index = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _Icon, _Secondary, _Primary) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _react = _interopRequireDefault(_react);
  Object.keys(_Icon).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Icon[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Icon[key];
      }
    });
  });
  Object.keys(_Secondary).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Secondary[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Secondary[key];
      }
    });
  });
  Object.keys(_Primary).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _Primary[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Primary[key];
      }
    });
  });
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
});
